import { render, staticRenderFns } from "./BottomTool.vue?vue&type=template&id=58c8b7e7&scoped=true"
import script from "./BottomTool.vue?vue&type=script&lang=js"
export * from "./BottomTool.vue?vue&type=script&lang=js"
import style0 from "./BottomTool.vue?vue&type=style&index=0&id=58c8b7e7&prod&lang=scss&scoped=true"
import style1 from "./BottomTool.vue?vue&type=style&index=1&id=58c8b7e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8b7e7",
  null
  
)

export default component.exports